export default "__VITE_ASSET__528a2588__"